import React, { useState } from 'react';

// Shared banner image for event/coaching cards.
// Falls back to a branded gradient + icon when the image is missing, broken,
// or a tiny/placeholder file (naturalWidth <= 2, e.g. seed 1x1 pngs).
export const CardBanner = ({ src, Icon, gradient = 'linear-gradient(135deg, #0A2C93 0%, #00D650 140%)', testId }) => {
  const [failed, setFailed] = useState(false);
  const showImg = src && !failed;

  return (
    <>
      {showImg && (
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
          onLoad={(e) => { if (e.currentTarget.naturalWidth <= 2) setFailed(true); }}
          data-testid={testId}
        />
      )}
      {!showImg && (
        <div className="w-full h-full flex items-center justify-center" style={{ background: gradient }} data-testid={testId ? `${testId}-fallback` : undefined}>
          {Icon && <Icon className="h-10 w-10 text-white/80" />}
        </div>
      )}
    </>
  );
};

export default CardBanner;
